// export const data = {
//   experience: [
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//   ],
//   education: [
//     {
//       title: "",
//       subTitle: "",
//       description: "",
//     },
//     {
//       title: "",
//       subTitle: "",
//       description: "",
//     },
//     {
//       title: "",
//       subTitle: "",
//       description: "",
//     },
//   ],
// };

// export const data = {
//   experience: [
//     {
//       title: "Gonior ",
//       subTitle: "Lod, ",
//       description: "Web development, Databases, Backend developement",
//     },
//   ],
//   education: [{ title: "", subTitle: "", description: "" }],
// };

export const data = {
  experience: [
    {
      title: "ג'וניור",
      subTitle: "לוד",
      description: " FRONT END, BACK END, DATABASES ",
    },
    // {
    //   title: "Senior Consultant",
    //   subTitle: "London, UK",
    //   description: "Web development, Databases, Backend developement",
    // },
    // {
    //   title: "Project Manager",
    //   subTitle: "Bangalore, INDIA",
    //   description: "Creative Direction Project Management, Team Leading",
    // },
  ],
  education: [
    // {
    //   title: "Secondary",
    //   subTitle: "ABC School",
    //   description: "10th Grade",
    // },
    // {
    //   title: "Higher Secondary",
    //   subTitle: "ABC School of higher education",
    //   description: "12th Grade in Science",
    // },
    {
      title: "--",
      subTitle: "--",
      description: "--",
    },
  ],
};
